export const checkBoxOption = {
  TRUE: 'TRUE',
  FALSE: 'FALSE',
};
